export const PERSONAL_TIMELINE_TEXT = {
	autoClose: 'auto close',
	loading: 'Loading',
	today: 'Today',
	todaySuffix: '(today)',
};
